<div class="form-control input-placeholder-to-label">
  <label class="has-float-label">
    <input type="tel" id="txtPhone" maxlength="10" placeholder="Teléfono (opcional)" name="opt-text"
      class="text-input inline text-09-d-demibold {{error.errorCss}}" [(ngModel)]="telePhone"
      (ngModelChange)="submitAnswer($event)" (keyup)="onClick($event)">
    <span>Teléfono (opcional)</span>
  </label>
  <p id="error-phone" class="error" *ngIf="error.isInValid">Para continuar, introduce un teléfono válido</p>
</div>
